export const defaultConfig = {
    LAUNCH_DARKLY_CLIENTID: 'not set',
    REACT_APP_APPINSIGHTS_INSTR_KEY: 'not set',
    REACT_APP_APPINSIGHTS_CONNECTION_STRING: 'not set',
    REACT_APP_APPINSIGHTS_CLOUD_ROLE_NAME: 'not set',
    REACT_APP_MSAL_CLIENT_ID: 'not set',
    REACT_APP_MSAL_TENANT_ID: 'not set',
    REACT_APP_MSAL_SIGNUPSIGNIN_POLICY: 'not set',
    REACT_APP_MSAL_FORGOTPASSWORD_POLICY: 'not set',
    REACT_APP_MSAL_EDITPROFILE_POLICY: 'not set',
    REACT_APP_MSAL_POLICY_AUTHORITY_ROOT: 'not set',
    REACT_APP_MSAL_B2C_AUTHORITYDOMAIN: 'not set',
    REACT_APP_BASEURL: 'not set',
    REACT_APP_BFF_API_BASEURL: 'not set',
    REACT_APP_CUSTOMER_BFF_API_BASEURL: 'not set',
    REACT_APP_BFF_API_SCOPES: 'not set',
    REACT_APP_CONFIG_FILE_VER: 'not set',
    REACT_APP_ENV: 'not set',
    REACT_APP_MFA_URL: 'not set',
    REACT_APP_CHANGE_PASSWORD_URL: 'not set',
    SCANDIT_KEY: 'not set',
    PERIPHERAL_SERVICES_PORT: 'not set',
    REACT_APP_MSAL_AAD_AUTHORITY: 'not set',
    MONERIS_HP_URL: 'not set',
    MONERIS_PROFILE_ID: 'not set',
    SAM_SGI_URL: 'not set',
    SAM_ISSUER_URL: 'not set',
    SAM_EXTERNAL_PARTNERS_URL: 'not set',
    MYSGI_URL: 'not set',
    VERIFY_CUSTOMER_POLICIES_URL: 'not set',
    SINGLE_LOG_OUT_URL: 'not set',
    CONNECT_MYSGI_CLASSIC_ACCOUNT_URL: 'not set'
};
